export default {
  "placeholder.input": "Additional Fields",
  "placeholder.select": "Select an option",
  "placeholder.search": "Search here...",
  "placeholder.selectDate": "Select a date",
  "placeholder.selectTime": "Select a time",
  "placeholder.enterText": "Please enter text",
  "placeholder.uploadFile": "Click or drag file to this area to upload",
  "placeholder.noData": "No data available",
  "placeholder.loading": "Loading, please wait...",
  "placeholder.error": "An error occurred, please try again",
  "placeholder.noResults": "No results found",
  "placeholder.selectMultiple": "Select multiple options",
  "placeholder.enterValue": "Enter a value",
  "placeholder.chooseFile": "Choose a file",
  "placeholder.enterEmail": "Enter your email address",
  "placeholder.enterPassword": "Enter your password",
  "placeholder.confirmPassword": "Confirm your password",
  "placeholder.enterUsername": "Enter your username",
  "placeholder.enterPhoneNumber": "Enter your phone number",
  "placeholder.enterAddress": "Enter your address",
  "placeholder.enterCity": "Enter your city",
  "placeholder.enterState": "Enter your state",
  "placeholder.enterZipCode": "Enter your zip code",
  "placeholder.enterCountry": "Enter your country",
  "placeholder.enterDescription": "Enter a description",
  "placeholder.enterSearchTerm": "Enter search term",
  "placeholder.selectCategory": "Select a category",
  "placeholder.selectOption": "Select an option",
  "placeholder.enterTitle": "Enter a title",
  "placeholder.enterName": "Enter your name",
  "placeholder.enterComment": "Enter your comment",
  "placeholder.enterFeedback": "Enter your feedback",
  "placeholder.enterNotes": "Enter your notes",
  "placeholder.enterDetails": "Enter details",
  "placeholder.enterMessage": "Enter your message",
  "placeholder.enterQuery": "Enter your query",
  "placeholder.enterSearchQuery": "Enter your search query",
  "placeholder.enterInput": "Enter your input",
  "placeholder.enterTextHere": "Enter text here",
  "placeholder.enterSearchText": "Enter search text",
  "placeholder.enterSearchKeyword": "Enter search keyword",
  "placeholder.enterSearchPhrase": "Enter search phrase",
  "placeholder.enterSearchValue": "Enter search value",
  "placeholder.enterSearchInput": "Enter search input",
  "placeholder.enterSearchField": "Enter search field",
  "placeholder.enterSearchCriteria": "Enter search criteria",
  "placeholder.enterSearchTermHere": "Enter search term here",
  "placeholder.enterSearchQueryHere": "Enter search query here",
  "placeholder.enterSearchKeywordHere": "Enter search keyword here",
  "placeholder.enterSearchPhraseHere": "Enter search phrase here",
  "placeholder.enterSearchValueHere": "Enter search value here",
  "placeholder.enterSearchInputHere": "Enter search input here",
  "placeholder.enterSearchFieldHere": "Enter search field here",
  "placeholder.enterSearchCriteriaHere": "Enter search criteria here",
  "placeholder.enterSearchTextHere": "Enter search text here",
  "placeholder.enterSearchInputValue": "Enter search input value",
  "placeholder.enterSearchInputText": "Enter search input text",
  "placeholder.enterSearchInputKeyword": "Enter search input keyword",
  "placeholder.enterSearchInputPhrase": "Enter search input phrase",
  "placeholder.enterSearchInputCriteria": "Enter search input criteria",
  "placeholder.enterSearchInputField": "Enter search input field",
  "placeholder.enterSearchInputTerm": "Enter search input term",
  "placeholder.enterSearchInputQuery": "Enter search input query",
  "placeholder.enterSearchInputValueHere": "Enter search input value here",
  "placeholder.enterSearchInputTextHere": "Enter search input text here",
  "placeholder.enterSearchInputKeywordHere": "Enter search input keyword here",
  "placeholder.enterSearchInputPhraseHere": "Enter search input phrase here",
  "placeholder.enterSearchInputCriteriaHere":
    "Enter search input criteria here",
  "placeholder.enterSearchInputFieldHere": "Enter search input field here",
  "placeholder.enterSearchInputTermHere": "Enter search input term here",
  "placeholder.enterSearchInputQueryHere": "Enter search input query here",
};
